import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";
import DriveEndType from "../../../../enums/drive-end-type";

export default class DeuceGoodNotAffectedByPenalty extends Rule {
    constructor() {
        super();
        this.penaltyAcceptedFragment = null;
        this.kickFragment = null;
        this.isDefensivePenalty = false;
    }

    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        let apply = true;

        if (fragment.associatedState === FootballState.DeuceGood) {
            this.kickFragment = play.getPreceedingFragment(
                fragment,
                FootballState.Kick
            );
            this.penaltyAcceptedFragment = play
                .getFragmentsBetween(fragment, [
                    FootballState.StatsCount,
                    FootballState.NoPlay
                ])
                .find(
                    ({ associatedState }) =>
                        associatedState === FootballState.PenaltyAccepted
                );

            this.isDefensivePenalty =
                this.penaltyAcceptedFragment &&
                this.penaltyAcceptedFragment?.causedBy?.teamId !==
                    this.kickFragment?.kickedBy?.teamId;

            apply = !this.penaltyAcceptedFragment || this.isDefensivePenalty;
        }

        return apply;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { play }) {
        const { homeTeamId, awayTeamId, gameConfig } = gameContext;

        // A deuce is a kickoff outcome: the receiving team takes over, so a new
        // drive must be cut for them. Mirror Turnover/KickOff — clear the
        // kicking team's drive and arm a new one; _createPendingPlays consumes
        // triggerDrive to create the receiver's drive.
        gameContext.setDriveContext({
            ...gameContext.getDriveContext(),
            previousDriveEndType: DriveEndType.Deuce,
            triggerDrive: true
        });
        gameContext.currentDriveId = null;

        const deucePoints = gameConfig.scoring.deuce;

        // Get the kicker info from the Kick fragment
        const { kickedBy } = play.getFirstFragment(FootballState.Kick) || {};
        const kickingTeamId = kickedBy?.teamId;
        const receivingTeamId =
            kickingTeamId === homeTeamId ? awayTeamId : homeTeamId;

        // Award points to the kicking team
        gameContext.increaseTeamScore(kickingTeamId, deucePoints);
        ruleContext.playPoints = deucePoints;

        // After a successful deuce, the receiving team gets the ball
        // at their own touchback yardline
        const { fieldLength } = gameConfig.general;
        const { touchbackYardline } = gameConfig.spots;
        gameContext.setPossessionForTeamId(receivingTeamId);
        gameContext.setFieldPosition(
            receivingTeamId === homeTeamId
                ? touchbackYardline
                : fieldLength - touchbackYardline
        );

        // If defensive penalty, also apply penalty field position
        if (this.penaltyAcceptedFragment) {
            gameContext.setFieldPosition(
                this.penaltyAcceptedFragment.fieldPosition
            );
        }
        ruleContext.setAwardFirstDown(true);
    }
}
